import TagManager from 'react-gtm-module';
import { getPagePath } from './index';

export const initializeGTM = () => {
  TagManager.initialize({
    gtmId: 'GTM-KT2QLJB',
  });
};

export const dataLayerGTM = (payload = {
  page_url: getPagePath(),
}) => {
  TagManager.dataLayer(payload);
};

export const initializeGTMWithEvent = (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};
